// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"2":"e51b480c","3":"bcd42b20","894":"df171643","998":"aea40eee"}[chunkId] + ".js";
};